var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTaxResidency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.437,
    height: 22.536,
    viewBox: "0 0 21.437 22.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22400",
    "data-name": "Group 22400",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22408",
    "data-name": "Group 22408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11599",
    "data-name": "Path 11599",
    d: "M.507,0a.507.507,0,1,0,0,1.014H1.993V21.8a.507.507,0,0,0,.843.379l2.5-2.22,2.226,2.2a.507.507,0,0,0,.7.012l2.381-2.206,2.225,2.194a.507.507,0,0,0,.707.006l2.308-2.212L18.4,22.175a.507.507,0,0,0,.843-.379V1.014H20.73A.507.507,0,1,0,20.73,0ZM2.836,1.014H18.4V20.67l-2.19-1.788a.507.507,0,0,0-.687.013l-2.289,2.194L11.017,18.9a.507.507,0,0,0-.7-.012L7.936,21.095,5.716,18.9a.507.507,0,0,0-.692-.019L2.836,20.67Z",
    fill: "#040227",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11600",
    "data-name": "Path 11600",
    d: "M106.632,266.667a.507.507,0,1,0,0,1.014h10.138a.507.507,0,1,0,0-1.014Z",
    transform: "translate(-101.082 -253.995)",
    fill: "#040227",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11601",
    "data-name": "Path 11601",
    d: "M106.632,320a.507.507,0,1,0,0,1.014h6.083a.507.507,0,1,0,0-1.014Z",
    transform: "translate(-101.082 -304.794)",
    fill: "#040227",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11602",
    "data-name": "Path 11602",
    d: "M127.322,75.5a1.718,1.718,0,1,0,1.718,1.718,1.725,1.725,0,0,0-1.718-1.718m0,1.014a.7.7,0,1,1-.7.7.7.7,0,0,1,.7-.7",
    transform: "translate(-119.635 -71.912)",
    fill: "#040227",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11603",
    "data-name": "Path 11603",
    d: "M250.739,140.209a1.718,1.718,0,1,0,1.718,1.718,1.725,1.725,0,0,0-1.718-1.718m0,1.014a.7.7,0,1,1-.7.7.7.7,0,0,1,.7-.7",
    transform: "translate(-237.188 -133.546)",
    fill: "#040227",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11604",
    "data-name": "Path 11604",
    d: "M174.26,64.493l-4.055,6.589a.507.507,0,0,0,.863.531l4.055-6.589a.507.507,0,0,0-.166-.7.535.535,0,0,0-.7.166",
    transform: "translate(-162.046 -61.21)",
    fill: "#040227",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaxResidency);
export default __webpack_public_path__ + "static/media/icon-tax-residency.e09bde7457471ee2f021b2cd631bd5a0.svg";
export { ForwardRef as ReactComponent };